// pages/limousine/index.jsx
/* eslint-disable @next/next/no-img-element */
import Image from "next/image";
import Header3 from "../../components/header/header-rslhome";
import Seo from "../../components/common/Seo";
import CtaButton from "../../components/buttonWithArrow";
import PickYourCarGrid from "../../components/Investments/PickYourCarToInvest";
import RoiInvestorBenefits from "../../components/Investments/RoiInvestorBenefits";
import { PERSONAL_CHAUFFEUR_page } from "../../data/personal-chauffeur";
import CommunicationChannel from "../../components/Investments/CommunicationChannel";
import Footer3 from "../../components/footer/footer-new";
import BookaCallEnquiry from '../../components/Investments/BookaCallEnquiry';
import CommercialCostCalculatore from "../../components/Investments/CommercialCostCalculatore";
import OverviewSection from "../../components/Investments/TourOverviewSection";
import TrustedPartners from "../../components/Investments/TrustedPartners";
import ActivateForm from "../../components/Investments/PersonalChaufferForm";
import OurPackage from "../../components/personal-chauffeur/OurPackages"
import { Box } from "@mui/material";
import { getChaufferPlanListNew } from "../../redux/slices/investments"
import { useDispatch, useSelector } from '../../redux/store';
import { useCallback, useEffect, useState } from "react";
import AfterFormSubmit from "../../components/investNow/AfterFormSubmit";
import fleetData from "../../data/fleets.json";
import { useRouter } from 'next/router'
import { bannerHeight } from "../../utils/bannerHeight";
import { fetchSeoByPage } from "../../lib/seoHelper";

const INITIAL_STATE = {
  vehicle: '',
  initial: '',
  monthly: '',
  month: ''
}

export default function PersonalChauffer({ meta }) {
  const HEADER_OFFSET = 88;
  const dispatch = useDispatch();
  const { chaufferPlanListData } = useSelector(
    state => state.investment
  );
  const [loading, setLoading] = useState(true);
  const { investNowRes } = useSelector(
    state => state.investment
  );
  const [openEnquire, setOpenEnquire] = useState(false)
  const [loader, setLoader] = useState(false)

  const [selectedPlan, setSelectedPlan] = useState(null);
  const id = sessionStorage.getItem("rslkeyId");
  const [subscriptionActived, setSubscriptionActived] = useState(false);
  const [bannerImage, setBannerImage] = useState(null);
  const router = useRouter()
  const currentPath = router.asPath

  const [chaufferPlanData, setchaufferPlanData] = useState([]);
  const [click, setClick] = useState(false);

  const smoothScrollTo = useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const y = el.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;
    window.scrollTo({ top: y, behavior: "smooth" });
  }, []);

  // If user lands with #section2 in the URL, smooth scroll and then clean it
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.location.hash === "#section2") {
      // allow first paint
      setTimeout(() => smoothScrollTo("section2"), 0);
    }
  }, [smoothScrollTo]);

  // When section2 is visible, remove the hash (keeps back button behavior)
  useEffect(() => {
    const target = document.getElementById("section2");
    if (!target || typeof window === "undefined") return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && window.location.hash) {
          history.replaceState(null, "", window.location.pathname + window.location.search);
        }
      },
      { threshold: 0.6 } // visible enough
    );

    obs.observe(target);
    return () => obs.disconnect();
  }, []);



  const onClose = () => {
    handleCloseEnquire();
    setOpenEnquire(false);
    setSelectedPlan(null);
  }


  useEffect(() => {
    setLoading(true);
    const obj = {
      passengerId: id ?? 9
    }
    dispatch(getChaufferPlanListNew(obj));
  }, []);

  useEffect(() => {
    if (chaufferPlanListData) {
      setLoading(false);
      if (chaufferPlanListData?.status === 1) {
        setchaufferPlanData(chaufferPlanListData?.data?.planDetails?.planList ?? []);
        setSubscriptionActived(chaufferPlanListData?.data?.hasActiveSubscription ?? false);
        setBannerImage(chaufferPlanListData?.data);
      } else {
        setchaufferPlanData([]);
        setSubscriptionActived(chaufferPlanListData?.data?.hasActiveSubscription ?? false);
        setBannerImage(null);
      }
    }
  }, [chaufferPlanListData])

  const handleCurrency = () => {
    setClick((prevState) => !prevState);
    sessionStorage.setItem("bookingPath", currentPath);
    // window.location.href = "/";
  };

  const handleOpenEnquire = (data) => {
    setSelectedPlan(data);
    // if (!id) {
    //   setClick(true);
    // } else {
    setOpenEnquire(true)
    // }

  }

  const handleCloseEnquire = () => { window.location.reload(); setOpenEnquire(false); setSelectedPlan(null) }

  const handleEnquirySubmit = (value) => {
    setLoader(true);
    const obj = {
      ...value,
      formType: 1,
      currency: typeof window !== "undefined"
        ? JSON.parse(sessionStorage.getItem("currency") || "{}")?.value || "aed"
        : "aed"
    }
    dispatch(limousineInvestNow(obj))
  }

  return (
    <>
      <Seo meta={meta} />
      <Header3 bgColor="#EBEBEB" borderColor="#DFDFDF" />

      <section className="hero">
        {/* BG image */}
        <Image
          // src="/img/personal-chauffeur/banner.svg"
          src={bannerImage?.bannerImage ? `${process.env.IMAGE_BASE_URL}/${bannerImage?.bannerImage}` : "/img/personal-chauffeur/banner.svg"}
          alt="limousine"
          fill
          priority
          sizes="100vw"
          style={{ objectFit: "cover" }}
        />
        {/* Gradient overlay */}
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            top: 0,
            background: "linear-gradient(to top, rgb(0 0 0 / 79%) 0%, rgba(0, 0, 0, 0) 50%)",
            zIndex: 1,
            pointerEvents: "none",
          }}
        />
        {/* dark gradient overlay */}
        {/* <div className="overlay" aria-hidden="true" /> */}

        {/* content */}
        <div className="content">
          <h1 className="title jura">
            Your Personal
            {" "} <span className="scribble-wrap">
              <span className="scribble-text">Chauffeur</span>
              {/* teal hand-drawn oval */}
              <img
                src="/img/personal-chauffeur/Oval.svg"
                alt=""
                className="scribble"
              />
            </span>
          </h1>

          <p style={{ color: "#f3f3f3", fontSize: "20px" }}>A ride you can trust for every occasion</p>

          <div className="cta">
            {
              subscriptionActived ?
                <CtaButton
                  label="Book Your Ride"                     // not needed, but harmless
                  onClick={(e) => {              // ⬅ prevent anchor hash
                    router.push("/carBooking/carBookRide?rideBooking=true")
                  }}
                /> :
                <CtaButton
                  label="Book Your Ride"
                  href="#"                       // not needed, but harmless
                  onClick={(e) => {              // ⬅ prevent anchor hash
                    e.preventDefault();
                    smoothScrollTo("package");
                  }}
                  endIconSrc="/img/header/VectorDown.svg"
                />
            }
          </div>
        </div>
      </section>
      <Box id="section2" sx={{ scrollMarginTop: { xs: '80px', md: '96px' } }}>
        <RoiInvestorBenefits data={{
          ...PERSONAL_CHAUFFEUR_page?.roiInvestorBenefits,
          button: { text: "Book Your Ride", link: "#", endIconSrc: !subscriptionActived },
          image: {
            src: bannerImage?.serviceBannerImage ? `${process.env.IMAGE_BASE_URL}/${bannerImage?.serviceBannerImage}` : PERSONAL_CHAUFFEUR_page?.roiInvestorBenefits?.image?.src,
            alt: " Hands offering coins"
          }
        }}
          right={{ xs: 0, md: 10, lg: 100, xl: 90 }} headingBottom={1} buttonMarginTop={{ xs: 0, md: 0 }} onClick={(e) => {
            if (subscriptionActived) {
              router.push("/carBooking/carBookRide?rideBooking=true")
            } else {
              e.preventDefault();
              smoothScrollTo("package");
            }
          }} />
      </Box>
      <Box id="package" sx={{ scrollMarginTop: { xs: '80px', md: '96px' } }}>
        <OurPackage loader={loading} data={chaufferPlanData} right={{ xs: 0, md: 10, lg: 100, xl: 90 }} buttonMarginTop={{ xs: 0, md: 0 }} onClose={onClose} handleOpenEnquire={handleOpenEnquire} />
      </Box>
      <CommunicationChannel data={PERSONAL_CHAUFFEUR_page?.communicationChannel} />
      <Footer3 bgcolor="#f8f8f8" />
      <style jsx>{`
        :global(html, body) {
         scroll-behavior: smooth;
          overflow-x: hidden;
        }

        .hero {
          position: relative;
          width: 100%;
          // min-height: clamp(80vh, 72vh, 80vh);
          min-height: ${bannerHeight()};
          border-radius: 0;
          isolation: isolate; /* ensure overlay/contents stack correctly */
        }

        .overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
              to top,
              rgba(0, 0, 0, 0.78) 0%,
              rgba(0, 0, 0, 0.55) 35%,
              rgba(0, 0, 0, 0.08) 70%,
              rgba(0, 0, 0, 0) 100%
            ),
            radial-gradient(60% 60% at 50% 50%, rgba(0, 0, 0, 0.25), transparent 70%);
          z-index: 1;
          pointer-events: none;
        }

        .content {
          position: absolute;
          inset: 0;
          z-index: 2;
          display: grid;
          place-items: end center;
          padding: clamp(16px, 4vw, 28px);
          /* push content slightly above bottom like the mock */
          align-content: end;
          gap: clamp(4px, 0vh, 28px);
          padding-bottom: clamp(36px, 10vh, 40px);
          text-align: center;
        }

        .title {
          color: #ffffff;
          font-weight: 600;
          letter-spacing: 0.02em;
          line-height: 1.1;
          margin: 0;
          /* responsive font like the design */
          font-size: clamp(28px, 6.5vw, 52px);
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
        }

        .scribble-wrap {
          position: relative;
          display: inline-block;
        }

        .scribble-text {
          position: relative;
          z-index: 2;
        }

        .scribble {
          position: absolute;
          z-index: 1;
          left: 0.0em;
          top: 5px;
          width: clamp(7.5em, 14vw, 13em); /* scales with font size */
          height: auto;
          transform: rotate(0deg);
          pointer-events: none;
          filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.25));
          opacity: 0.95;
        }

        .cta {
          display: flex;
          justify-content: center;
        }

        /* Button polish to match mock (rounded pill + subtle shadow) */
        :global(.cta button),
        :global(.cta a) {
          border-radius: 999px !important;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
        }

        /* Responsive tweaks */
        @media (max-width: 768px) {
          .content {
            padding-bottom: 48px;
          }
          .scribble {
            left: -0.3em;
            top: 10px;
          }
        }

        @media (max-width: 420px) {
          .title {
            line-height: 1.08;
            letter-spacing: 0.01em;
          }
          .scribble {
            width: 8.8em;
          }
        }
      `}</style>

      <ActivateForm
        open={openEnquire}
        handleCloseEnquire={handleCloseEnquire}
        onClose={onClose}
        fleetCard={fleetData}
        handleSubmit={handleEnquirySubmit}
        loader={loader}
        setLoader={setLoader}
        labels={["Name", "Email", "Phone"]}
        apiResponse={investNowRes}
        selectedPlan={selectedPlan}
        setSelectedPlan={setSelectedPlan}
      />

      <div
        className={`currencyMenu js-currencyMenu ${click ? "" : "is-hidden"}`}
      >
        <div className="currencyMenu__bg" onClick={handleCurrency}></div>
        <div className="currencyMenu__signpop bg-white rounded-4">
          <div className="d-flex items-center justify-between px-30 py-20 sm:px-15 border-bottom-light">
            {/* End Title */}
            <div />

            <button className="pointer" onClick={handleCurrency}>
              <i className="icon-close" />
            </button>
            {/* End colse button */}
          </div>
          {/* End flex wrapper */}
          <div
            className="text-20 fw-500 lh-15 px-30  py-30 sm:px-15 sm:py-15"
            style={{
              textAlign: "center",
            }}
          >
            To continue Booking, please sign in to your account
          </div>
          <div
            className="px-30  py-30 sm:px-15 sm:py-15"
            style={{
              textAlign: "center",
            }}
          >

            <button
              className="btn bg-dark-3 text-white"
              onClick={() => {
                // router.push("/sign-in/sign-in");
                sessionStorage.setItem("isSig", true);
                setClick(false);
              }}
            >
              Sign In
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}